// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oXWM","content":"styles_content__10aaW"};